import { useEffect, useRef } from "react";

// Escape cierra SÓLO el modal de arriba. Hoy los del panel de la unidad se
// reemplazan (historial de comandos → detalle desmonta uno y monta el otro),
// pero con un listener suelto en cada modal, el día que dos convivan un Escape
// los cerraría a la vez. Una pila compartida y un único listener lo evitan.
const stack: Array<{ current: () => void }> = [];

// defaultPrevented: react-select (Crear evento, Evidencias) cierra su menú con
// Escape llamando preventDefault sin detener el evento; sin este chequeo el
// mismo Escape cerraba también el modal y se perdía el formulario.
const onKeyDown = (e: KeyboardEvent) => {
  if (e.key !== "Escape" || e.defaultPrevented || stack.length === 0) return;
  e.stopPropagation();
  stack[stack.length - 1].current();
};

export function useEscapeKey(onEscape: () => void, enabled = true) {
  const ref = useRef(onEscape);
  ref.current = onEscape;

  useEffect(() => {
    if (!enabled) return;
    const entry = ref;
    stack.push(entry);
    if (stack.length === 1) document.addEventListener("keydown", onKeyDown);
    return () => {
      const i = stack.lastIndexOf(entry);
      if (i >= 0) stack.splice(i, 1);
      if (stack.length === 0) document.removeEventListener("keydown", onKeyDown);
    };
  }, [enabled]);
}
